function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
!function (t, r) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? r(exports, require("apollo-link"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "apollo-link", "react"], r) : r(t.reactApolloNetworkStatus = {}, t.apolloLink, t.react);
}(this, function (t, r, e) {
  var n;
  !function (t) {
    t.REQUEST = "REQUEST", t.ERROR = "ERROR", t.SUCCESS = "SUCCESS", t.CANCEL = "CANCEL";
  }(n || (n = {}));
  var o = n,
    i = function (t) {
      function e(r) {
        t.call(this), this.dispatcher = r;
      }
      return t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e, e.prototype.request = function (t, e) {
        var n = this;
        this.dispatcher.dispatch({
          type: o.REQUEST,
          payload: {
            operation: t
          }
        });
        var i = e(t);
        return new r.Observable(function (r) {
          var e = !0,
            u = i.subscribe({
              next: function next(i) {
                e = !1, n.dispatcher.dispatch({
                  type: o.SUCCESS,
                  payload: {
                    operation: t,
                    result: i
                  }
                }), r.next(i);
              },
              error: function error(i) {
                e = !1, n.dispatcher.dispatch({
                  type: o.ERROR,
                  payload: {
                    operation: t,
                    networkError: i
                  }
                }), r.error(i);
              },
              complete: r.complete.bind(r)
            });
          return function () {
            e && n.dispatcher.dispatch({
              type: o.CANCEL,
              payload: {
                operation: t
              }
            }), u && u.unsubscribe();
          };
        });
      }, e;
    }(r.ApolloLink),
    u = function u() {
      this.listeners = [];
    };
  function a(t, r, n) {
    var o = e.useReducer(r, n),
      i = o[0],
      u = o[1];
    return e.useEffect(function () {
      var r;
      function e(t) {
        r = requestAnimationFrame(function () {
          u(t);
        });
      }
      return t.addListener(e), function () {
        t.removeListener(e), cancelAnimationFrame(r);
      };
    }, [t]), i;
  }
  function s(t, r) {
    return t.query.definitions.some(function (t) {
      return "OperationDefinition" === t.kind && t.operation === r;
    });
  }
  function c(t) {
    return function (r, e) {
      if (void 0 === r && (r = 0), !s(e.payload.operation, t)) return r;
      switch (e.type) {
        case o.REQUEST:
          return r + 1;
        case o.ERROR:
        case o.SUCCESS:
        case o.CANCEL:
          return Math.max(r - 1, 0);
      }
      return r;
    };
  }
  function p(t) {
    return function (r, e) {
      if (!s(e.payload.operation, t)) return r;
      switch (e.type) {
        case o.REQUEST:
          return;
        case o.ERROR:
          var n = e.payload;
          return {
            networkError: n.networkError,
            operation: n.operation
          };
        case o.SUCCESS:
          var i = e.payload,
            u = i.result;
          return u && u.errors ? {
            graphQLErrors: u.errors,
            response: u,
            operation: i.operation
          } : r;
      }
      return r;
    };
  }
  u.prototype.addListener = function (t) {
    this.listeners.push(t);
  }, u.prototype.removeListener = function (t) {
    this.listeners = this.listeners.filter(function (r) {
      return r !== t;
    });
  }, u.prototype.dispatch = function (t) {
    this.listeners.forEach(function (r) {
      r(t);
    });
  };
  var f = c("query"),
    l = c("mutation"),
    d = p("query"),
    E = p("mutation"),
    y = {
      numPendingQueries: 0,
      numPendingMutations: 0,
      queryError: void 0,
      mutationError: void 0
    };
  function h(t) {
    return !1 !== t.getContext().useApolloNetworkStatus;
  }
  t.ActionTypes = o, t.createNetworkStatusNotifier = function () {
    var t = new u();
    return {
      link: new i(t),
      useApolloNetworkStatus: function useApolloNetworkStatus(r) {
        return function (t, r) {
          r || (r = {});
          var n,
            o,
            i = (n = r.shouldHandleOperation || h, o = e.useRef(function () {
              throw new Error("Function is called before it was assigned.");
            }), e.useLayoutEffect(function () {
              o.current = n;
            }), e.useCallback(function () {
              for (var t = [], r = arguments.length; r--;) t[r] = arguments[r];
              return o.current.apply(o, t);
            }, []));
          return a(t, e.useMemo(function () {
            return function (t, r) {
              return i(r.payload.operation) ? function (t, r) {
                if (s(r.payload.operation, "subscription")) return t;
                var e = Object.assign({}, t);
                return e.numPendingQueries = f(e.numPendingQueries, r), e.numPendingMutations = l(e.numPendingMutations, r), e.queryError = d(e.queryError, r), e.mutationError = E(e.mutationError, r), Object.keys(t).some(function (r) {
                  return e[r] !== t[r];
                }) ? e : t;
              }(t, r) : t;
            };
          }, [i]), y);
        }(t, r);
      },
      useApolloNetworkStatusReducer: function useApolloNetworkStatusReducer(r, e) {
        return a(t, r, e);
      }
    };
  };
});
//# sourceMappingURL=index.umd.js.map